import React from "react";
import Spinner from "./Spinner";

const LoadMore = ({ loading, visible, onLoadMoreClick }) => {
  if (!visible) return null;
  if (loading) {
    return <Spinner />;
  }
  return (
    <div className="container d-flex justify-content-center mt-3">
      <div onClick={onLoadMoreClick} style={{ cursor: "pointer" }} className="mx-auto d-inline-block text-center px-3 py-1 hover:bg-grey2 cursor-pointer rounded-pill fs-sm bg-grey1 text-black w-max-content">
        {"Load More"}
      </div>
    </div>
  );
};

export default LoadMore;
